import { LitElement, html, css } from 'lit';

class DashboardLoadingOverlay extends LitElement {
  static styles = css`
    :host {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 3000;
    }
    .loading-container {
      position: relative;
      display: flex;
      align-items: center;
    }
    .spinner {
      position: absolute;
      border: 5px solid rgba(255, 255, 255, 0.3);
      border-top: 5px solid white;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      animation: spin 1s linear infinite;
      bottom: 40px;
      
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .text {
      color: white;
    }
  `;

  render() {
    return html`
      <div class="loading-container">
        <div class="spinner"></div>
        <div class="text">処理中...</div>
      </div>
    `;
  }
}

customElements.define('dashboard-loading-overlay', DashboardLoadingOverlay);
